import { gql, useMutation } from "@apollo/client"
import { useToast } from "@chakra-ui/react"

export const verifyPdfAccessible = async (url: string): Promise<boolean> => {
  try {
    const response = await fetch(url, { method: "HEAD" })
    return response.ok
  } catch {
    // CORS or network error — cannot determine, assume accessible
    return true
  }
}

const REPORT_ERROR_MUTATION = gql`
  mutation ReportError($context: String!, $detail: String!) {
    reportError(context: $context, detail: $detail)
  }
`

interface ReportErrorOptions {
  context: string
  detail: string
  userMessage?: string
}

export const useReportError = () => {
  const toast = useToast()
  const [sendErrorReport] = useMutation(REPORT_ERROR_MUTATION)

  const reportError = ({ context, detail, userMessage }: ReportErrorOptions): void => {
    toast({
      title: "Report Unavailable",
      description: userMessage ?? "This report is not currently available. Our support team has been notified.",
      status: "warning",
      duration: 6000,
      isClosable: true
    })
    sendErrorReport({ variables: { context, detail } }).catch(() => {})
  }

  return { reportError }
}
